// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"c0063570","450":"d406ed53","453":"105794ca","455":"9b132388","977":"44cb6e38"}[chunkId] + ".chunk.js";
};